import React from 'react';
import { Icons } from './Icons';

export const NotificationToast = ({ message, type, onClose }: { message: string, type: 'error' | 'success', onClose: () => void }) => {
  return (
    <div className={`fixed bottom-6 left-1/2 transform -translate-x-1/2 z-[60] flex items-start gap-3 px-6 py-4 rounded-xl shadow-2xl max-w-md w-full animate-slide-up ${
      type === 'error' ? 'bg-red-50 border border-red-200 text-red-900' : 'bg-green-50 border border-green-200 text-green-900'
    }`}>
      <div className={`mt-0.5 ${type === 'error' ? 'text-red-500' : 'text-green-500'}`}>
        {type === 'error' ? <Icons.Info /> : <span className="text-lg">✓</span>}
      </div>
      <div className="flex-1 text-sm font-medium">{message}</div>
      <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors">
        <Icons.X />
      </button>
    </div>
  );
};
